import useApi, { ApiOptions } from '../base/useApi';
import InventorySelectionItemDTO from '@src/adapters/dto/inventory/InventorySelectionItemDTO';

interface Params {
  filter: string;
}

interface Result {
  inventories: InventorySelectionItemDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/inventory/for_selection/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindInventoriesForSelection = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindInventoriesForSelectionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindInventoriesForSelection;
